import * as React from 'react';
import { IFilesPopperContentProps } from '../../FileUploader.types';
import {
  nameSpace,
  testIds,
  TRANSLATION_FALLBACKS,
  TRANSLATION_KEYS,
} from '../../constants';
import { FileName } from '../FileName/FileName';
import style from './style/FilesPopperContent.scss';

export const FilesPopperContent: React.FunctionComponent<IFilesPopperContentProps> = ({
  files,
  disabled,
  onFileRemoval,
  onXIconKeyDown,
  withErrorIndication,
  withErrorTooltip,
  validationMessage,
  id,
  uploadStatus,
  popperStyles,
  popperAttributes,
  popperRef,
  isFixedPositionPopper,
  closePopper,
  translate,
}) => {
  const hasFiles = !!files.length;
  const isPlaceholder = !hasFiles;

  const handleFileRemoval: React.MouseEventHandler<SVGSVGElement> = e => {
    e.stopPropagation();
    if (files.length === 1) {
      closePopper();
    }

    onFileRemoval(e);
  };

  const getPopperStyleOverrides = () => {
    let styles = {};

    if (isFixedPositionPopper) {
      styles = {
        inset: 'auto auto 0',
        bottom: 0,
        transform: 'unset',
        position: 'fixed',
      };
    }

    return styles;
  };

  return (
    <div
      id={`popper-content`}
      ref={popperRef}
      data-testid={testIds.filesPopper}
      {...popperAttributes}
      className={style.popper}
      style={{
        ...popperStyles,
        ...getPopperStyleOverrides(),
      }}
    >
      {files.map((file, index) => (
        <FileName
          id={id}
          key={`${index}-${file.name}`}
          fileName={file.name}
          disabled={disabled}
          isPlaceholder={isPlaceholder}
          withErrorIndication={withErrorIndication}
          withErrorTooltip={withErrorTooltip}
          validationMessage={validationMessage}
          onFileRemoval={handleFileRemoval}
          onXIconKeyDown={onXIconKeyDown}
          withCenterEllipsis={true}
          uploadStatus={uploadStatus}
          withPopperBehaviour
          isFixedPositionPopper={isFixedPositionPopper}
        />
      ))}
      {isFixedPositionPopper && (
        <>
          <div
            data-testid={testIds.mobileSeperator}
            className={style.seperator}
          />
          <div
            data-testid={testIds.mobileCloseButton}
            className={style.closeButton}
            onClick={closePopper}
          >
            {translate(
              nameSpace,
              TRANSLATION_KEYS.FileUploader_Mobile_ClosePopper,
              TRANSLATION_FALLBACKS.FileUploader_Mobile_ClosePopper,
            )}
          </div>
        </>
      )}
    </div>
  );
};
